<template>
  <page-layout title="지급 명세서">
    <template v-slot:content>
      <div class="header-layout">
        <div class="header-content">
          <div class="header-content-left">
            <div class="select-date">
              <v-select
                  v-model="baseYm"
                  :items="baseYmList"
                  item-text="text"
                  item-value="value"
                  @change="changeBaseYm(baseYm)"
                  outlined hide-details dense
                  background-color="white"
              ></v-select>
            </div>
            <div class="buttons-layout">
              <v-tabs v-model="active">
                <v-tab @click="changeType('statement')">명세서</v-tab>
                <v-tab @click="changeType('detail')">상세</v-tab>
              </v-tabs>
            </div>
          </div>
          <v-btn v-if="pageType === 'statement'" class="button excel" outlined @click="createPDF" :disabled="disabledExcel">
            다운로드
          </v-btn>
        </div>
        <div class="contents-layout">
          <payment-detail
            v-if="pageType === 'statement'"
            :member-info="memberInfo"
            :detail-title="detailTitle"
            :detail-data="detailData"
            :is-create-pdf="isCreatePdf"
            @endCreatePdf="endCreatePdf"
          />
          <payment-detail-list
            v-if="pageType === 'detail'"
            :detail-list="detailList"
          />
        </div>
      </div>
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import PaymentDetail from "@/pages/Payment/components/PaymentStatement/PaymentDetail.vue";
import DateMixin from "@/mixin/DateMixin";
import {axiosInstance} from "@/util/AxiosModule";
import TableMixin from "@/mixin/TableMixin";
import PaymentDetailList from "@/pages/Payment/components/PaymentStatement/PaymentDetailList.vue";
import store from "@/store";

export default {
  name: "PaymentStatement",
  components: {PaymentDetailList, PaymentDetail, PageLayout},
  mixins: [DateMixin, TableMixin],
  props: ["rowData"],
  data() {
    return {
      active: [0, 1],
      baseYm: "",
      baseYmList: [],
      memberId: "",
      detailTitle: null,
      memberInfo: null,
      detailData: {},
      detailList: [],
      pageType: "statement",
      isCreatePdf: false
    }
  },
  computed: {
    disabledExcel() {
      if (!this.detailData) return true;
      return Object.keys(this.detailData).length === 0;
    }
  },
  async mounted() {
    if (this.rowData) {
      this.memberId = this.rowData.memberId;
    } else {
      this.memberId = store.getters["login/memberId"];
    }
    await this.getBaseYm();

    const defaultBaseYm = this.baseYm;
    this.baseYmList = this.getYearMonthList("202601", defaultBaseYm);
    this.baseYm = this.rowData ? this.rowData.baseYm : defaultBaseYm;
    await this.getPaymentDetail(this.baseYm);
  },
  methods: {
    async getBaseYm() {
      try {
        const response = await axiosInstance.get("/private/statement/lastBaseYM");

        if (response.data === undefined || response.data === null) {
          this.baseYm = "";
        } else {
          this.baseYm = String(response.data).trim();
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    changeBaseYm(date) {
      if (!date) return;
      this.getPaymentDetail(date);
    },
    async getPaymentDetail(date) {
      try {
        const { data } = await axiosInstance.get("/private/statement", {
          params: {
            memberId: this.memberId,
            baseYm: date
          }
        });
        if (!data.info) {
          this.detailData = {};
          this.detailTitle = null;
          this.memberInfo = null;
          this.detailList = [];
        } else {
          this.detailData = data.info;
          const settlementDate = `${this.baseYm.slice(0, 4)}년${String(this.baseYm.slice(4, 6)).padStart(2, "0")}월`;
          const paymentDate = `${this.detailData.paymentYmd.slice(0, 4)}년${this.detailData.paymentYmd.slice(4, 6)}월`;
          this.memberInfo = `(${this.detailData.memberNm}: ${this.setSsnoMasking(this.detailData.ssno)})`;
          this.detailTitle = `실적월: ${settlementDate}(지급월: ${paymentDate}) 수수료지급명세표`;

          this.detailList = data.detailList;
        }
      } catch (error) {
        await this.showAlert({ message: `${error.response.data.message}` });
      }
    },
    changeType(type) {
      this.pageType = type;
    },
    createPDF() {
      this.isCreatePdf = true;
    },
    endCreatePdf() {
      this.isCreatePdf = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .select-date {
    width: 150px;
    z-index: 10;
  }
  .buttons-layout {
    margin-left: 10px;
  }
  .header-content-left {
    display: flex;
    align-items: center;
  }
}
</style>